import { createFileRoute } from '@tanstack/react-router'
import { Settings } from '@/features/emails/settings'

export const Route = createFileRoute('/_authenticated/emails/settings')({
  component: Settings,
})
